export { default } from './TitleTextMultiColumnImageTitleText';
export type {
  IPrismicTitleTextMultiColumnImageTitleTextItem,
  IPrismicTitleTextMultiColumnImageTitleTextPrimary,
} from './types';
